<template>
    <div>
        <topTab ref="topTab" :tabData="tabData" @tabChange="changePages">
            <el-form :inline="true" :model="formInline" class="user-search">
                <el-form-item label="年份">
                    <el-date-picker v-model="dateStr" type="year" size="small" :default-value="new Date()"
                        :editable="false" :clearable="false" placeholder="请选择年份" format="yyyy年" @change="dateChange">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="门店">
                    <el-select v-model="formInline.storeKeyId" placeholder="请选择门店" clearable filterable size="small"
                        style="width: 100%;" @change="getListData">
                        <el-option v-for="item in storeList" :label="item.value" :value="item.keyId"
                            :key="item.keyId"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button v-if="this.$checkBtnPermission('/storeCost/statistic/store', 'viewPage')" size="small"
                        type="primary" class="el-icon-search" @click="getListData()">
                        搜索
                    </el-button>
                </el-form-item>
            </el-form>
            <span class="content_title">
                {{ this.title }}
            </span>

            <el-table :data="listData" v-loading="loading" :span-method="objectSpanMethod" border stripe
                style="border-radius: 10px;" :highlight-selection-row="true" empty-text="暂无数据"
                :cell-style="{ padding: '0', lineheight: '0' }" :header-cell-style="{ backgroundColor: '#b3e0ff' }"
                height="600px">
                <el-table-column prop="startRowIndex" label="序号" align="center" fixed="left" width="80" isKeep="true">
                </el-table-column>
                <el-table-column prop="name" label="门店名称" isKeep="true" minWidth="120" align="center">
                </el-table-column>
                <el-table-column prop="typeName" label="费用类型" minWidth="100" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.$index % (typeCount + 2) === 0" class="xiaBo">{{ scope.row.typeName }}</span>
                        <span v-else-if="scope.$index % (typeCount + 2) === typeCount + 1" class="total">{{
                            scope.row.typeName }}</span>
                        <span v-else>{{ scope.row.typeName }}</span>
                    </template>
                </el-table-column>
                <el-table-column v-for="m in 12" prop="listCounts[m-1]" :key="m" :label="m + '月'" minWidth="100"
                    align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.$index % (typeCount + 2) === 0" class="xiaBo">{{ scope.row.listCounts[m - 1]
                            }}</span>
                        <span v-else-if="scope.$index % (typeCount + 2) === typeCount + 1" class="total">{{
                            scope.row.listCounts[m - 1] }}</span>
                        <span v-else>{{ scope.row.listCounts[m - 1] }}</span>
                    </template>
                </el-table-column>
            </el-table>
        </topTab>
    </div>
</template>

<script>
import {
    GetStoreCostStatistic
} from "@/api/storeCostApi.js";
import { GetOrgInfoListByConfig } from "@/api/organizationalApi.js";
export default {
    data() {
        return {
            activeTab: "1",
            tabData: [
                {
                    key: "1",
                    value: "费用统计",
                },
            ],
            loading: false, // 显示加载
            listData: [],
            typeCount: 1,
            formInline: {
                year: new Date().getFullYear(),
                storeKeyId: "",
            },
            title: "门店费用统计",
            dateStr: new Date(),
            storeList: [],
        };
    },
    // 注册组件
    components: {
    },
    created() {
        this.GetOrganizationListByConfig();
    },
    computed: {},
    methods: {
        changePages() { },
        //显示编辑界面
        handleEdit(row) {
            this.$refs.edit.editShow(row);
        },
        // 获取门店列表
        GetOrganizationListByConfig() {
            const paramer = {
                key: 1,
            };
            GetOrgInfoListByConfig(paramer)
                .then((res) => {
                    if (res.code == 1) {
                        this.storeList = [];
                        res.data.forEach((item) => {
                            this.storeList.push({
                                keyId: item.keyId,
                                value: item.name + '【' + item.remark2 + '】',
                            });
                        });
                        this.formInline.storeKeyId = this.storeList[0].keyId;
                        this.getListData();
                    } else {
                        this.$message.error(res.msg);
                    }
                })
                .catch((err) => {
                    this.loading = false;
                    this.$message.error("获取门店信息失败!");
                });
        },
        // 获取列表
        getListData() {
            this.loading = true;
            this.title = this.formInline.year + "年各门店费用统计";
            GetStoreCostStatistic(this.formInline)
                .then((res) => {
                    if (res.code == 1) {
                        this.loading = false;
                        this.listData = res.data.listItems;
                        this.typeCount = res.data.typeCount;
                    } else {
                        this.$message({
                            type: "info",
                            message: res.msg,
                        });
                    }
                })
                .catch((err) => {
                    this.loading = false;
                    this.$message.error("数据加载失败，请稍后再试！");
                });
        },
        // 搜索事件
        search() {
            this.getListData();
        },
        // 日期选择器change事件
        dateChange() {
            this.formInline.year = this.dateStr.getFullYear();
            this.getListData();
        },
        objectSpanMethod({ row, column, rowIndex, columnIndex }) {
            if (columnIndex === 0 || columnIndex === 1) {
                if (rowIndex % (this.typeCount + 2) === 0) {
                    return {
                        rowspan: this.typeCount + 2,
                        colspan: 1
                    };
                } else {
                    return {
                        rowspan: 0,
                        colspan: 0
                    };
                }
            }
        }
    },
};
</script>

<style scoped lang="scss">
.content_title {
    font-size: 32px;
    font-weight: 700;
    display: block;
    text-align: center;
    margin-bottom: 20px;
}

.xiaBo {
    width: 100%;
    height: 100%;
    display: inline-block;
    font-weight: bold;
    background-color: aquamarine;
}

.total {
    width: 100%;
    height: 100%;
    display: inline-block;
    font-weight: bold;
    background-color: antiquewhite;
}

::deep.el-table__body .cell {
    padding: 0 !important;
}
</style>